const inspectionResults = [
    {
        "uuid": "1",
        "customerNo": "00001",
        "customerName": "中農粉絲有限公司",
        "tseyueAssessmentStandard": true,
        "leezenAssessmentStandard": false,
    },
    {
        "uuid": "2",
        "customerNo": "00002",
        "customerName": "源天然股份有限公司",
        "tseyueAssessmentStandard": true,
        "leezenAssessmentStandard": true,
    },
    {
        "uuid": "3",
        "customerNo": "00003",
        "customerName": "豆之家食品有限公司",
        "tseyueAssessmentStandard": false,
        "leezenAssessmentStandard": true,
    },
    {
        "uuid": "4",
        "customerNo": "00004",
        "customerName": "黑松股份有限公司",
        "tseyueAssessmentStandard": true,
        "leezenAssessmentStandard": true,
    },
]

export default inspectionResults;